import { defineStore } from 'pinia';

import { apiClient } from '@/Clients/ApiClient';
import CommunicationService from '@/Services/Admin/CommunicationService';

const communicationService = new CommunicationService(apiClient);

export const usePledgeManagerReminderStore = defineStore({
    id: 'pledgeManagerReminder',
    state: () => ({
        pledgeManagerReminderData: {
            unfinishedPledgesOwnersCount: 0,
            reminderRecipientsCount: 0,
            unsubscribedUsersCount: 0,
            pledgeManagerReminderFrequencyInDays: 0,
        },
        canPledgeManagerReminderBeSent: false,
        pledgeManagerReminderLockedUntil: null,
        isPledgeManagerReminderModalVisible: false,
    }),
    actions: {
        async loadPledgeManagerReminderFrequencyStatus(projectID) {
            return await communicationService.validatePledgeManagerReminderCanBeSent(projectID);
        },
        async loadPledgeManagerReminderData(projectID) {
            return await communicationService.getPledgeManagerReminderPreview(projectID);
        },
        handleLoadPledgeManagerReminderStatus( { data: { canBeSent, pledgeReminderLockedUntil } } ) {
            this.canPledgeManagerReminderBeSent = canBeSent;
            this.pledgeManagerReminderLockedUntil = pledgeReminderLockedUntil;
        },
        handleLoadPledgeManagerReminderBehavior({ data }) {
            this.pledgeManagerReminderData = {
                ...this.pledgeManagerReminderData,
                ...data,
            };
        },
        openPledgeManagerReminderModal() {
            this.isPledgeManagerReminderModalVisible = true;
        },
        onModalClose() {
            this.isPledgeManagerReminderModalVisible = false;
        },
    },
    getters: {
        pledgeManagerReminderTooltipText: state => dateFormatted => state.pledgeManagerReminderLockedUntil
            ? `You can\'t send pledge manager reminders now because you sent them recently.
                    You\'ll be able to send them again on ${ dateFormatted }`
            : 'You\'ll be able to send these notifications after opening the pledge manager.',
        canSendPledgeManagerReminder: state => isPledgeManager => isPledgeManager && state.canPledgeManagerReminderBeSent,
    },
});